import type { StatsigUser } from '@statsig/react-bindings';

import * as cookie from 'js/lib/cookie';
import { get as getUser } from 'js/lib/user';

/**
 * StatsigUser factory
 * TODO: ohazda - figure out if it's harmful always setting stableID when user is present
 * TODO: ohazda: do we need to use anything else as fallback if our cookie is not available? For example this can be a problem in iFrame on a third party domain
 */
const createStatsigUser = (): StatsigUser => {
  const user = getUser();
  return {
    userID: user?.id?.toString(),
    customIDs: { stableID: cookie.get('__204u') || '' },
  };
};

export default createStatsigUser;
